<template>
  <a-select
    v-model:value="innerValue"
    mode="multiple"
    :style="{ width: '100%' }"
    :placeholder="placeholder"
    :filter-option="fuzzyMatchOption"
    @change="handleChange">
    <a-select-option
      v-if="!allOptionSelected"
      :value="'__all__'">
      <span style="font-weight: bold; color: #1890ff;">Выбрать всё</span>
    </a-select-option>

    <a-select-option
      v-for="option in options"
      :key="option.id"
      :value="option.id"
      :label="option.name">
      {{ option.name }}
    </a-select-option>
  </a-select>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { fuzzyMatchOption } from '@/helpers/fuzzyMatchOption';

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Выберите значения',
  },
});

const emit = defineEmits(['update:modelValue']);

const innerValue = ref([...props.modelValue]);
const allOptionSelected = computed(() => innerValue.value.length === props.options.length);

watch(() => props.modelValue, (newVal) => {
  innerValue.value = [...newVal];
});

const allOptionValues = computed(() => props.options.map((o) => o.id));

function handleChange(value) {
  if (value.includes('__all__')) {
    emit('update:modelValue', allOptionValues.value);
  } else {
    emit('update:modelValue', value);
  }
}
</script>
